/*
 * @title App
 * @description Application entry point
 */

// Polyfills
import 'Utils/_closest.polyfill.js';
import 'Utils/_matches.polyfill.js';

// Misc
// Use log() instead of console.log()
// const log = console.log.bind(console);

// Modules
//import carousel from 'Modules/carousel/carousel';
import navbar from 'Modules/navbar/navbar';
//import searchOverlay from 'Modules/search-overlay/search-overlay';


// Components
import collapse from 'Components/collapse.js';
import smoothScroll from 'Components/smooth-scroll';
import toggleElement from 'Components/toggle-element';
//import login from 'Modules/login/login';
import newlogin from 'Modules/login/newlogin';
import product from 'Modules/product/product';
import checkout from 'Modules/checkout/checkout';
import user from 'Modules/admin/user';
import search from 'Modules/admin/search';
import sort from 'Modules/admin/sort';
import actions from 'Modules/actions/actions';


document.addEventListener('DOMContentLoaded', function() {
  const path = window.location.pathname;

  // Modules
  //carousel();
  navbar();
  //searchOverlay();
  console.log(path);
  if(path === '/' || path === "/catalog.html"){
    actions();
  }

  if(path === "/login.html" || path === "/login" || path === "/login/exit" || path === "/login/error"){
    newlogin(); smoothScroll();
  }
  if(path.indexOf('catalog') !== -1 || path === "/product.html" || path === "/products.html"){
    product();
  }
  if(path.indexOf('checkout') !== -1 ){
    checkout();
  }
  if(path === '/dsb/users'){
    search();
  }
  if(path === '/dsb/orders'){
    sort();
  }
  if(path.indexOf('dsb/user') !== -1 && path !== '/dsb/users' ){
    user();
  }

  // Components
  collapse();
  //smoothScroll();
  toggleElement();
  window.removeFromCart = (id) => {
      const data = new FormData();
      data.append('id', id);
      fetch('/order/remove', {
        method: 'POST',
        body: data
      })
      .then(result => result.text())
      .then((result) => {
        console.log(result);
        document.location.reload(true);
      })
    }
    window.checkConnect = () => {
      fetch('/login/sklad', {
        method: 'POST',
      })
      .then(result => result.text())
      .then((result) => {
        console.log(result);
        if (result !== "true") {
          window.location.href = '/login/error';
        }

      })
      .catch(function(err) {
        console.log('Fetch Error :-S', err);
      });
    }

    window.moveto = (path) => {
      sessionStorage.setItem(window.location.pathname, window.scrollY);
      window.location.href=path;
    }

    window.promtHide = (path) => {
      var isTrue = confirm("Категория будет скрыта. Ок?");
      if(isTrue){
        window.location.href=path;
      }
    }
    window.promtShow = (path) => {
      var isTrue = confirm("Категория будет показана в каталоге. Ок?");
      if(isTrue){
        window.location.href=path;
      }
    }
    window.promt = (path) => {
      var isTrue = confirm("Категория будет удалена. Ок?");
      if(isTrue){
        window.location.href=path;
      }
    }
  window.promtAction = (path) => {
    var isTrue = confirm("Акция будет удалена. Ок?");
    if(isTrue){
      window.location.href=path;
    }
  }

})
